'use client'

import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

export const Error500Content = () => {
  const t = useTranslations()

  return (
    <main className='mb-6 flex flex-col gap-8'>
      <h1 className='text-3xl font-medium'>{t('serverErr.title')}</h1>
      <div className='border-grey-20 flex flex-col items-center justify-center gap-3 rounded border px-16 py-8'>
        <div className='relative h-80 min-h-40 w-full'>
          <Image
            src='/images/errors/500.svg'
            fill
            alt='500 | Something went wrong'
          />
        </div>
        <p className='whitespace-pre-wrap'>{t('serverErr.msg')}</p>
        <Button variant='contained' onClick={() => location.reload()}>
          {t('actions.reload')}
        </Button>
      </div>
    </main>
  )
}
